import Vue from 'vue';
import vuex from 'vuex';

Vue.use(vuex);
const store = new vuex.Store({
	state: {
		count: 0
	},
	mutations: {
		increment (state) {
			state.count++;
		}
	}
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js